import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  validationService,
  formatDate,
} from 'utils';

import { Title } from 'components/landing/components/title';
import { Block } from 'components/landing/components/block';
import { Content } from 'components/landing/components/content';

import config from 'config/config';
import { formSchema } from './config';
import Form from './Form';
import Done from './Done';
import './DemoForm.css';

const dumbDemoForm = dumbBem('demo-form');
const DemoFormWrp = tx(dumbDemoForm)('div');

export class DemoForm extends Component {
  constructor(props) {
    super(props);

    const inputsState = validationService.getStateValue(formSchema);
    this.state = {
      ...inputsState,
      sendForm: false,
      showDone: false,
    };

    _.bindAll(this, [
      'showActiveBorder',
      'handleInputBlur',
      'handleInputFocus',
      'handleInputChange',
      'handleSubmit',
      'getErrorMsg',
    ]);
  }

  handleInputBlur(event) {
    const value = _.get(event, 'target.value');
    const name = _.get(event, 'target.name');
    const errorName = `${name}Error`;
    const element = formSchema.find(item => item.name === name);
    const errorMsg = validationService.getErrorMsg(element, value);

    if (errorMsg) this.setState({ [`${name}Active`]: false });
    else this.setState({ [errorName]: null, [`${name}Active`]: false });
  }

  handleInputFocus(event) {
    const name = _.get(event, 'currentTarget.name');
    this.setState({ [`${name}Active`]: true });
  }

  handleInputChange(event) {
    const value = _.get(event, 'currentTarget.value');
    const name = _.get(event, 'currentTarget.name');
    const state = { [name]: value };
    this.setState(state);
  }

  showActiveBorder(name, value) {
    const inputActive = this.state[`${name}Active`];
    return inputActive || value.length;
  }

  showError(name) {
    return !!this.getErrorMsg(name);
  }

  getErrorMsg(name) {
    return this.state[`${name}Error`];
  }

  isButtonDisabled() {
    return !validationService.isFormValid(formSchema, this.state);
  }

  handleSubmit() {
    const isValid = validationService.isFormValid(formSchema, this.state);
    if (isValid) this.sendDataToCRM();
    else this.displayAllErrors();
  }

  sendDataToCRM() {
    const { first_name, last_name, email, business_name, phone } = this.state;

    this.setState({ sendForm: true });
    setTimeout(() => { this.setState({ showDone: true }); }, 500);

    const name = `${first_name} ${last_name}`;
    const created_at = Date.now();
    const formatedDate = formatDate(created_at, 'DD/MM/YYYY');
    const website = email.trim().replace(/(.+@)/, '');
    const company_id = (created_at + email).slice(0, 60);

    window.Intercom('boot', {
      app_id: config.intercomePublicKey,
      email,
      created_at: formatedDate,
      name,
      phone,
      companies: [
        {
          company_id,
          name: business_name,
          created_at: formatedDate,
          website,
        },
      ],
    });
  }

  displayAllErrors() {
    for (const element of formSchema) {
      const name = element.name;
      const value = this.state[element.name];
      const errorName = `${name}Error`;
      const errorMsg = validationService.getErrorMsg(element, value);
      if (errorMsg) this.setState({ [errorName]: errorMsg });
    }
  }

  render() {
    const {
      sendForm,
      showDone,
    } = this.state;

    const {
      title,
      requestBtnTitle,
      __ref,
    } = this.props;

    return (
      <DemoFormWrp __ref={__ref}>
        <Block modifier="form">
          <Content hidden={sendForm}>
            <Title>{title}</Title>

            <Form
              handleSubmit={this.handleSubmit}
              requestBtnTitle={requestBtnTitle}
              parentState={this.state}
              getErrorMsg={this.getErrorMsg}
              handleInputBlur={this.handleInputBlur}
              handleInputFocus={this.handleInputFocus}
              handleInputChange={this.handleInputChange}
            />
          </Content>

          {showDone && <Done />}
        </Block>
      </DemoFormWrp>
    );
  }
}

export default DemoForm;

DemoForm.propTypes = {
  title: PropTypes.string.isRequired,
  requestBtnTitle: PropTypes.string.isRequired,
  __ref: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/landing/components/demoForm/DemoForm.js